import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { StationEditorData } from "../../state/Stations/EditorData";


const updateStationsEditorData: Reducer<StationEditorData> = (state: StationEditorData = new StationEditorData(), action: Action<ActionType, StationEditorData>) => {
  switch (action.type) {
    case ActionType.STATIONS_EDITOR_DATA_RESET:
      return new StationEditorData();
    case ActionType.STATIONS_EDITOR_DATA_FETCHED:
      return { ...state, stationData: action.data };
    case ActionType.STATIONS_EDITOR_DATA_COPIED:
      return { ...state, stationData: { ...action.data} };
    case ActionType.STATIONS_EDITOR_DATA_UPDATED:
      return { ...state, stationData: { ...state.stationData, ...action.data } };
    case ActionType.STATIONS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.STATIONS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    default:
      return state;
  }
};

export default updateStationsEditorData;